<div class="row mb-3">
  <div class="col" id="content">
    <span class="material-symbols-outlined pe-4" id="arrow" (click)="goBack()"> arrow_back </span>
    <h3 class="d-none d-lg-block" id="title">{{ title() }}</h3>
    <h3 class="d-block d-lg-none">{{ subTitle() }}</h3>
  </div>
</div>
